import { render, staticRenderFns } from "./send-sms.vue?vue&type=template&id=7dfea84d&"
import script from "./send-sms.vue?vue&type=script&lang=js&"
export * from "./send-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports